import { useEffect, useState } from 'react';
import { createRoute } from '@tanstack/react-router';

import { rootRoute, useAppRouterInitial } from '../routerBase';
import { FrameSkeleton } from '../../components/Skeleton/FrameSkeleton';
import { useTranslation } from '../../hooks/useTranslation';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
// Type-only import so the route chunk stays split — the runtime module is
// loaded via dynamic import() inside the route's effect (see below).
import type Dashboard from '../../components/Dashboard/index';

function DashboardRouteComponent() {
  const { papercutUrl } = useAppRouterInitial();
  const { t } = useTranslation();
  useDocumentTitle(t('common.page_titles.dashboard'));
  const [Component, setComponent] = useState<typeof Dashboard | null>(null);
  useEffect(() => {
    import('../../components/Dashboard/index').then((mod) => {
      setComponent(() => mod.default);
    });
  }, []);
  if (!Component || !papercutUrl) {
    return <FrameSkeleton />;
  }
  return <Component papercutUrl={papercutUrl} />;
}

export const dashboardIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dashboard',
  component: DashboardRouteComponent,
});

// Root path serves the same page: `root "dashboard#index"` mounts this section.
export const dashboardRootRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: DashboardRouteComponent,
});
